export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-xl font-heading font-bold text-background-50">51吃瓜网</span>
            <p className="text-sm text-background-400 mt-3 leading-relaxed">
              51吃瓜网官网是国内领先的娱乐资讯聚合平台，提供最新51吃瓜网站入口、
              永久域名及APP下载。支持手机版和网页版一键直达，确保用户快速访问平台，
              获取最新最热的娱乐八卦、影视综艺、网红动态等全方位吃瓜内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: 'APP下载', id: '#app' },
                { label: '热搜榜单', id: '#ranking' },
                { label: '热门话题', id: '#topics' },
                { label: '焦点专题', id: '#carousel' },
                { label: '联系我们', id: '#contact' },
              ].map((link) => (
                <a
                  key={link.id}
                  href={link.id}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(link.id);
                  }}
                  className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。如有合作意向，欢迎通过联系我们页面提交合作申请。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">访问入口</h4>
            <div className="flex flex-col gap-2">
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#app');
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                手机版入口
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#app');
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-computer-line"></i>
                网页版入口
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#app');
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-download-cloud-2-line"></i>
                APP下载
              </a>
              <span className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-background-400">
                <i className="ri-links-line"></i>
                永久域名访问
              </span>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 51吃瓜网官网 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}